import React, { Component } from 'react'
import ReactSelect from 'react-select'
import axios from 'axios';
import {axiosEH} from '../common/functions'
import jwtUser from '../../jwtUser';


export default class SelectClass extends Component {
  constructor() {
    super()
    this.state = {
      className: '',
      classList: [],
      statusMsg: ''
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    this.setState({
      [event.target.name]: event.target.value.trim()
    })
  }

  handleSubmit(event) {
    event.preventDefault();
    let url = process.env.REACT_APP_BASEURL + '/userclasses/selectclass';
    const user = jwtUser(); // get user token

    axios.post(url, {username: user.username,className: this.state.className,},{ headers: { 'x-access-token': user['x-access-token'] } })
      .then(res => {  // {}
        //console.log(JSON.stringify(res.data));
        if (res.data.hasOwnProperty('info')) {
          this.setState({statusMsg: res.data.info})
        } else {
          sessionStorage.setItem('selectedClassname', this.state.className);
          sessionStorage.setItem('sc-tbTaskType', res.data.tbTaskType);
          sessionStorage.setItem('sc-spellingTimeoutSec', res.data.spellingTimeoutSec);
          sessionStorage.setItem('sc-taskDueDays', res.data.taskDueDays);
          sessionStorage.removeItem('schoolID');
          window.location.reload();
        }
      })
      .catch(err => { 
        //this.setState.setStatusMsg(axiosEH(err)); 
        this.setState({statusMsg: err})
      })
  }

  componentDidMount() {
    let classList = JSON.parse(sessionStorage.getItem("classList"));
    if (classList !== null) {
      this.setState(() => {
        return {
          classList: classList.map(e=> e.className)
        }
      })
    }
  }
  // end of f()

  render() {
    return (
      <section className="login-form is-medium mx-5">

        <div className="select is-danger" style={{width:'80%'}}>
            <select name='className' onChange={this.handleChange} >
                <option >Class list ...</option>
                {this.state.classList.map((option, index) => {
                    return (
                        <option key={index}>
                            {option}
                        </option>
                    );
                })}
            </select>
          </div>

        <button className="button is-success" onClick={this.handleSubmit}>
          SelectClass
        </button>
        <br></br>
        <label className="label has-text-success">{this.state.statusMsg}</label>
      </section>
    )
  }
}